import { useEffect, useState } from 'react'


const useForceRerender = () => {
  const [isFirstRender, setIsFirstRender] = useState(true)

  useEffect(() => {
    setIsFirstRender(false)
  }, [])

  return isFirstRender
}


export default useForceRerender
